module.exports = __webpack_public_path__ + "img/Honigloeffel-v2-200.a71db49e.png";